import { httpRequest } from '@calendly/http-tools'

import { stripeClientSecretFetched, stripeClientSecretPending } from '../../../actions/payment'

export const fetchPackageClientSecret = (packageUuid) => async (dispatch, getState) => {
  const state = getState()
  const { status } = state.scheduling.stripeClientSecret

  if (status !== 'ready' || !packageUuid) return

  dispatch(stripeClientSecretPending())

  // Use the new RESTful endpoint
  const [ok, res] = await httpRequest({
    url: `/api/booking/packages/${packageUuid}/stripe_payment_intents`,
    method: 'POST'
  })

  if (ok) {
    dispatch(stripeClientSecretFetched(res.resource.client_secret, res.resource.stripe_account))
  } else {
    dispatch({ type: 'SET_STRIPE_CLIENT_SECRET', payload: { status: 'ready', value: null, stripeAccount: null } }) // Reset to default
  }
}
